import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import VideoSurveyInventoryContextProvider from "../../context/VideoSurveyInventoryContext";
import { NotificationToast } from "../Generic/Toast/NotificationToast";
import useConnectionOptions from "./hooks/useConnectionOptions";
import SurveyScreen from "./SurveyScreen";
import { VideoProvider } from "./VideoProvider";

const VideoSurvey = () => {
  const { t: translate } = useTranslation();
  const connectionOptions = useConnectionOptions();

  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (error) NotificationToast.error(error?.message || translate("unknownError"));
  }, [error]);

  return (
    <div>
      <VideoProvider options={connectionOptions} onError={setError}>
        <VideoSurveyInventoryContextProvider>
          <SurveyScreen />
        </VideoSurveyInventoryContextProvider>
      </VideoProvider>
    </div>
  );
};

export default VideoSurvey;
